import { diligenceObservable } from "../../../observers/deligenceObservable";
import { Select } from "../../ui/Select"
import React, { useCallback, useMemo } from "react"
import { useLocation } from "react-router-dom";

export const SelectUBOType = React.memo(({renderBy, index, value, onChange, label = undefined, name="uboType", required=undefined, changeType='value', disabled, isReport}) => {
    const location = useLocation();
    // Resolve the label based on the current pathname
  const resolvedLabel =
  location.pathname === "/management-structure"
    ? "Type of Manager"
    : label || "UBO Type";
    // label = label || "UBO Type";
    name = name || "uboType";
    required = required || true;

    const handleChange = useCallback((e) => {
        diligenceObservable.removeByPrefix(renderBy + Number(index).toString())
        if (changeType === 'value') {
            onChange(e.target.value);
        } else {
            onChange(e);
        }
    }, [renderBy, index, changeType, onChange]);

    const baseOptons = useMemo (()=> {
        const options = [
            { value: "Private Company", display_value: "Private Company" },
            { value: "Partnership", display_value: "Partnership" },
            { value: "Company Listed on a Recognised Stock Exchange", display_value: "Public Limited Company" },
            { value: "Regulated Entity", display_value: "Regulated Entity" },
            { value: "Pension Fund", display_value: "Pension Fund" },
            { value: "Trust", display_value: "Trust" },
            { value: "Unit Trust", display_value: "Unit Trust" },
            { value: "Fund", display_value: "Fund" },
            { value: "Public Sector Bodies, governments, state owned companies and local authorities.", display_value: "Public Sector Bodies, governments, state owned companies and local authorities." },
            { value: "Foundations", display_value: "Foundations" },
            { value: "Sovereign Wealth Funds", display_value: "Sovereign Wealth Funds" },
            { value: "Church bodies", display_value: "Church bodies" },
            { value: "Charities", display_value: "Charities" },
        ]
        if (renderBy === "corporate") {
            options.unshift({ value: "Private Individual (Natural Person)", display_value: "Private Individual" });
        }
        return options;
        
    }, []);

    return (
        <div className="form-group">
            <Select 
                isReport={isReport}
                label={resolvedLabel}
                required={required}
                value={value}
                name={name}
                disabled={disabled}
                onChange={handleChange}
                options={baseOptons}
            />
        </div>
    )
})